import { useQuery } from '@tanstack/react-query';
import { getAuthenticatedApiClient, QUERY_KEYS } from '../client';

export interface Department {
  id: string;
  name: string;
}

export const useDepartments = () => {
  return useQuery({
    queryKey: QUERY_KEYS.departments,
    queryFn: async (): Promise<Department[]> => {
      const apiClient = getAuthenticatedApiClient();
      const relativeUrl = '/api/departments';
      const fullUrl = `${(apiClient as any).baseUrl}${relativeUrl}`;
      
      const response = await (apiClient as any).http.fetch(fullUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch departments: ${response.statusText}`);
      }

      const body = await response.json();
      return body.departments;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes - departments don't change often
  });
};